import React from 'react';
import { EmptyStateRow, TableLoader } from 'features/command-center/components';
import { COMMAND_CENTER_BASE_URL, ENDPOINTS } from 'features/command-center/constants';
import { useFetchWithStatusV2 } from 'hooks/fetchWithStatus';
import { SECONDARY_API_CLIENT } from 'services/API';
import { UIStatus } from 'UI/constants/status';

import { formatTransactionByWeekResponse } from '../../fallOffsBoard.utils';

import { ExpandableRow } from './ExpandableRow';

export const TransactionsByWeek = ({ columns, selectedTransactionId, queryParams }) => {
  const endpoint = `${COMMAND_CENTER_BASE_URL}/${ENDPOINTS.fallOffsTransactionsByWeek.replace(
    ':id',
    selectedTransactionId
  )}?${queryParams}`;

  const { state } = useFetchWithStatusV2({
    endpoint,
    apiInstance: SECONDARY_API_CLIENT
  });

  const formattedData = formatTransactionByWeekResponse(state?.results);

  if (state.status === UIStatus.Loading) return <TableLoader colSpan={columns.length} />;

  if (!formattedData) return <EmptyStateRow colSpan={columns.length} />;

  return formattedData.map(row => <ExpandableRow key={row.empNo} row={row} columns={columns} />);
};
